import React, { useState, useEffect, useMemo, useContext } from "react";
import { useAppContext } from "../../App.jsx";
import { useQueries } from "@tanstack/react-query";
import {
  q_prizebox_txns,
  qiserr,
  qissuccesss,
} from "../../queries/queries.jsx";
import { getv, nils } from "../../utils/utils.jsx";
import { useAuthContext } from "../../wrappers/AuthWrapper.jsx";
import { useLayoutContext } from "../../components/Layout.jsx";
import { Tag, Img } from "../../components/utilityComps.jsx";
import { metamaskimg } from "../../utils/links.jsx";
import { twMerge } from "tailwind-merge";
import { Loader01c } from "../../components/anims.jsx";
import _ from "lodash";
import {
  PrizeBoxSection,
  TransactionTable,
  PrizeboxContext,
  GlassCard,
  GlowButton,
  TransactionTableSkeleton,
} from "./dependencies.jsx";
import { PrizeboxPopupOverlay } from "./PrizeboxPopupOverlay.jsx";
import { usePageContext } from "./PrizeboxPage.jsx";

// Side panel component for transactions
export const PrizeboxSidePanel = () => {
  const appcon = useAppContext();
  const { psearch } = appcon;
  
  const aucon = useAuthContext();
  const vault = useMemo(() => {
    if (!nils(psearch.v)) return psearch.v.toLowerCase();
    return aucon.vault;
  }, [psearch.v, aucon.vault]);

  const [qo_txns] = useQueries({
    queries: [q_prizebox_txns({ vault, boxtype: 1 }, { enabled: !nils(vault) })],
  });

  return (
    <div className="h-full flex flex-col pt-2">
      
      <div className="h-[80vh] md:h-[60vh] overflow-hidden">
        {qo_txns.isLoading ? (
          <TransactionTableSkeleton />
        ) : qiserr(qo_txns) ? (
          <GlassCard className="p-8 h-full flex items-center justify-center hover-lift">
            <p className="text-center text-red-300 resp-text--1">
              {qiserr(qo_txns)}
            </p>
          </GlassCard>
        ) : qissuccesss(qo_txns) &&
          _.isEmpty(getv(qo_txns, "data.result.txns")) ? (
          <GlassCard className="p-8 h-full flex items-center justify-center hover-lift">
            <div className="text-center">
              <div className="text-4xl mb-3 opacity-50">📦</div>
              <p className="text-yellow-300 resp-text--1">
                No transactions found
              </p>
            </div>
          </GlassCard>
        ) : qissuccesss(qo_txns) &&
          !_.isEmpty(getv(qo_txns, "data.result.txns")) ? (
          <PrizeboxContext.Provider value={{ qo_txns }}>
            <TransactionTable />
          </PrizeboxContext.Provider>
        ) : null}
      </div>
    </div>
  );
};

export const PrizeboxTab = () => {
  const appcon = useAppContext();
  const { psearch, upd_psearch } = appcon;
  const tokenid = 1;
  const boxtype = tokenid;

  const aucon = useAuthContext();
  const { auth } = aucon;
  const vault = useMemo(() => {
    if (!nils(psearch.v)) return psearch.v.toLowerCase();
    return aucon.vault;
  }, [psearch.v, aucon.vault]);

  const laycon = useLayoutContext();
  const pagecon = usePageContext();
  const { tab } = pagecon;

  const [qo_txns] = useQueries({
    queries: [q_prizebox_txns({ vault, boxtype }, { enabled: !nils(vault) })],
  });

  const [showopen, set_showopen] = useState(false);
  const [box_error, set_box_error] = useState(null);

  useEffect(() => {
    if (!nils(psearch.boxopentx)) {
      set_showopen(true);
    }
  }, [psearch.boxopentx]);

  const pcon = { vault, qo_txns, set_showopen, box_error, set_box_error };

  return (
    <PrizeboxContext.Provider value={pcon}>
      <div className="">
        {/* Only show modal when this is the active tab */}
        {showopen && tab === "prizebox" ? <PrizeboxPopupOverlay pcon={pcon} /> : null}
        
        {/* Prize Box Section - Full Width */}
        <div className="w-full pt-2">

          {auth !== true ? (
            <div className="flex justify-center">
              <GlassCard className="p-8 text-center max-w-md">
                <div className="space-y-6">
                  <h3 className="text-r3lig font-digi resp-text-1">
                    Please connect your wallet to continue
                  </h3>
                  <GlowButton
                    onClick={laycon.open_loginpop}
                    variant="primary"
                    className="flex items-center gap-3 px-6 py-3"
                  >
                    <div className="w-6 h-6">
                      <Img img={metamaskimg} />
                    </div>
                    <span>Connect Wallet</span>
                  </GlowButton>
                </div>
              </GlassCard>
            </div>
          ) : (
            <PrizeBoxSection />
          )}
        </div>
      </div>
    </PrizeboxContext.Provider>
  );
};
